<template>
    <el-container class="page-x" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">用户信息</span>
                <el-input class="input-box" clearable placeholder="用户ID,姓名、手机号、证件号" v-model.trim="searchBox.keyword"></el-input>
            </div>
            <div class="search-item">
                <span class="label">订单号</span>
                <el-input class="input-box" placeholder="订单号" clearable v-model.trim="searchBox.likeOrderNo"></el-input>
            </div>
            <div class="search-item">
                <span class="label">印刷号</span>
                <el-input class="input-box" placeholder="印刷号" clearable v-model.trim="searchBox.likePrintNo"></el-input>
            </div>
            <div class="search-item">
                <span class="label">服务项目名称</span>
                <select-all v-model="searchBox.itemIds"
                    :data="serviceList"
                    :option="{label: 'itemName', value: 'id'}">
                </select-all>
            </div>
            <div class="search-item">
                <span class="label">数据来源</span>
                <select-all  v-model="searchBox.orderSources"
                    :data="optionsData.orderSourceList"
                    :option="{label: 'label', value: 'value'}">
                </select-all>
            </div>
            <div class="search-item">
                <span class="label">订单来源</span>
                <select-all v-model="searchBox.bookingSources"
                    :data="optionsData.bookingSourceList"
                    :option="{label: 'label', value: 'value'}">
                </select-all>
            </div>
            <div class="search-item">
                <span class="label">接收渠道</span>
                <select-all v-model="searchBox.channels"
                    :data="optionsData.channelList"
                    :option="{label: 'label', value: 'value'}">
                </select-all>
            </div>
            <div class="search-item">
                <span class="label">供应商</span>
                <select-all v-model="searchBox.providerIds"
                    :data="supplierList"
                    :option="{label: 'providerName', value: 'id'}">
                </select-all>
            </div>
            <div class="search-item">
                <span class="label">订单生成时间</span>
                <el-date-picker
                        ref="orderDate"
                        v-model="timeRange_3"
                        type="daterange"
                        @change="toChangeTime_3"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-value="timeDefaultShow"
                        value-format="timestamp"
                        :picker-options="{
                            disabledDate(time) {
                                return time.getTime() > Date.now();
                            },
                        }"
                >
                </el-date-picker>
            </div>
            <div class="search-item">
                <span class="label">预约体检时间</span>
                <el-date-picker
                        v-model="timeRange_1"
                        type="daterange"
                        @change="toChangeTime_1"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="timestamp"
                >
                </el-date-picker>
            </div>
            <div class="search-item">
                <span class="label">状态</span>
                <select-all v-model="searchBox.examStatuses"
                    :data="statusList"
                    :option="{label: 'label', value: 'id'}">
                </select-all>
            </div>
            <div class="search-item">
                <span class="label">完成时间</span>
                <el-date-picker
                        v-model="timeRange_2"
                        type="daterange"
                        @change="toChangeTime_2"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="timestamp"
                        :default-value="timeDefaultShow"    
                        :picker-options="{
                            disabledDate(time) {
                                return time.getTime() > Date.now();
                            },
                        }"
                >
                </el-date-picker>
            </div>
            <!--添加权限码-->
            <el-button v-auth="'sa_order_page'"  type="primary"  @click="toSearch">查询</el-button>
            <el-button v-auth="'sa_order_page'"  type="primary"  @click="() => $root.showPage = false">重置</el-button>
            <el-button v-auth="'sa_order_export'" type="warning"  @click="toExport">导出</el-button>
        </div>
        <div class="table-x" ref="tableBox">
            <el-table 
                v-loading="loading"
                :data="tableData"
                height="600"
                border
                class="mb20">
                <el-table-column 
                    type="index"
                    align="center"
                    label="序号"
                    width="60">
                </el-table-column>
                <el-table-column 
                    prop="orderNo"
                    align="center"
                    label="订单号"
                    width="200">
                </el-table-column>
                <el-table-column 
                    prop="printNo"
                    align="center"
                    width="160"
                    label="印刷号">
                </el-table-column>
                <el-table-column 
                    prop="createTime"
                    align="center"
                    width="160"
                    label="订单生成时间">
                    <template slot-scope="scope">
                        {{ scope.row.createTime}}
                    </template>
                </el-table-column>
                <el-table-column 
                    align="center"
                    width="120"
                    label="数据来源">
                    <template slot-scope="scope">
                        {{ scope.row.orderSource | optionsFilter(optionsData.orderSourceList) }}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="channel"
                    align="center"
                    width="120"
                    label="接收渠道">
                </el-table-column>
                <el-table-column 
                    prop="itemName"
                    align="center"
                    width="120"
                    label="服务项目名称">
                </el-table-column>
                <el-table-column
                    prop="userId"
                    align="center"
                    label="用户ID">
                    <template slot-scope="scoped">
                        <span>{{ scoped.row.userId ? scoped.row.userId : "--" }}</span>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="name"
                    align="center"
                    label="用户姓名">
                </el-table-column>
                <el-table-column 
                    prop="mobile"
                    align="center"
                    width="120"
                    label="手机号">
                </el-table-column>
                <el-table-column 
                    align="center"
                    label="证件类型">
                    <template slot-scope="scoped">
                        <span>{{
                            cardType[scoped.row.cardType] || scoped.row.cardType
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="cardNo"
                    align="center"
                    label="证件号">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="性别">
                    <template slot-scope="scope">
                        {{ scope.row.gender === 1 ? '女':'男'}}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="age"
                    align="center"
                    label="年龄">
                </el-table-column>
                <el-table-column  
                    align="center"
                    label="婚姻状况">
                    <template slot-scope="scope">
                        {{ scope.row.marital === 0 ? '未知': (scope.row.marital === 1 ? '已婚' : '未婚')}}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="状态">
                    <template slot-scope="scope">
                        {{ num2Text(scope.row.examStatus,scope.row.orderStatus, 'statusList')}}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="orderUpdateTime" 
                    align="center"
                    width="120"
                    label="状态更新时间">
                </el-table-column>
                <el-table-column 
                    align="center"
                    label="订单来源">
                        <template slot-scope="scope">
                        {{ scope.row.bookingSource | optionsFilter(optionsData.bookingSourceList) }}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="bookingDate" 
                    align="center"
                    label="预约体检时间">
                    <template slot-scope="scope">
                        {{ scope.row.bookingDate ? scope.row.bookingDate.substring(0,10) : ''}}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="providerAbbr" 
                    align="center"
                    label="供应商">
                </el-table-column>
                <el-table-column 
                    prop="policyNo" 
                    align="center"
                    label="保单号">
                </el-table-column>
                <el-table-column 
                    align="center"
                    label="保单状态">
                    <template slot-scope="scope">
                        {{ scope.row.policyStatus | optionsFilter(policyStatusList) }}
                    </template>
                </el-table-column>
                <el-table-column 
                    align="center"
                    label="预约网点">
                    <template slot-scope="scope">
                        <span v-if="scope.row.hospName">{{ scope.row.hospName }} - </span>
                        <span v-if="scope.row.hospProvince">{{ scope.row.hospProvince }}/</span>
                        <span v-if="scope.row.hospCity">{{ scope.row.hospCity }}/</span>
                        <span v-if="scope.row.hospArea">{{ scope.row.hospArea }}</span>
                    </template>
                </el-table-column>
                <el-table-column 
                    label="操作"
                    width="120px"
                    align="center">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button v-auth="'sa_provider_view'" type="text" size="middle" class="table-btn" @click="statusHandle(scope.row)">状态轨迹</el-button>
                        <el-button v-if="scope.row.examStatus == 8" v-auth="'sa_exam_detail_download'" type="text" size="middle" class="table-btn" @click="toDetail(scope.row)">查看</el-button>
                        <el-button v-if="scope.row.examStatus == 8" v-auth="'sa_exam_detail_download'" type="text" size="middle" class="table-btn" @click="downloadFile(scope.row)">下载</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <div class="pagenation-x">
            <div class="pagination mb20">
                <el-pagination 
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="searchBox.pageNo"
                    :page-size="searchBox.pageSize"
                    :page-sizes="[10,50,100]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background>
                </el-pagination>
            </div>
        </div>

        <el-dialog title="状态轨迹" :visible.sync="statustTrackFlag" center>
            <div class="tableScroll">
                <el-table :data="statusData" border>
                    <el-table-column property="date" label="状态">
                        <template slot-scope="scope">
                            {{ scope.row.targetStatus | targetStatusFilter }}
                        </template>
                    </el-table-column>
                    <el-table-column property="operation" label="操作">
                        <template slot-scope="scope">
                            {{ scope.row.operation | operationFilter }}
                        </template>
                    </el-table-column>
                    <el-table-column property="changeTime" label="时间" width="200"></el-table-column>
                    <el-table-column property="remark" label="备注"></el-table-column>
                </el-table>
            </div>
            
            <div class="footerInfo">取消体检预约共计{{count}}次</div>
        </el-dialog>

    </el-container>
</template>
<script>
    const _statusList = [
        {label: '待预约', id: 1},
        {label: '已预约', id: 2},
        {label: '已到检', id: 3},
        {label: '体检逾期', id: 4},
        {label: '已出报告', id: 5},
        {label: '已撤销', id: 6},
        // {label: '取消预约', id: 7},
        {label: '已完成', id: 8},
        {label: '订单取消', id: 9},
        {label: '到检取消', id: 10},
    ];

    import {isArray, dateFormat, dataArrFormat} from '@/assets/js/until.js'
    import { dataSourceList,cardType,policyStatusList } from "@/assets/js/options";
    import { saveAs } from 'file-saver';
    // 带全选功能的下拉框
    import SelectAll from "@/components/SelectAll";
    import Qs from 'qs'
    export default{
        components: {
            SelectAll
        },
        data(){
            return {
                loading: false,
                dataSourceList,//数据来源
                cardType,// 证件类型
                policyStatusList, // 保单状态
                timeDefaultShow: '', // 日期控件默认选择日期
                tableHeight: 0,
                // 查询条件
                timeRange_1: [],
                timeRange_2: [],
                timeRange_3: [],
                searchBox: {
                    pageSize: 10,
                    pageNo: 1,
                    keyword: '',        // 用户信息关键字（用户ID,姓名、手机号、证件号）
                    likeOrderNo: '',    // 订单号
                    likePrintNo: '',     // 体检函编码
                    providerIds: [],   // 供应商
                    finishStartDate: '', // 完成开始时间
                    finishEndDate: '',   // 完成结束日期
                    bookingStartDate: '', // 预约开始时间
                    bookingEndDate: '',     // 预约结束时间
                    createStartDate: '',     // 订单生成时间开始
                    createEndDate: '',     // 订单生成时间结束
                    examStatuses: [],     // 体检状态
                },
                statusList: _statusList,
                supplierList: [],
                serviceList: [], // 服务项目列表
                optionsData: {
                    orderSourceList: [],
                    channelList: [],
                    orderSourceList: []
                }, // 筛选项数据
                tableData: [],
                total: 0,
                statusData:[],  // 状态轨迹 - 列表
                statustTrackFlag: false, // 状态轨迹 - visible
                count: 0, // 状态轨迹 - 取消体检预约次数
            }
        },
        created(){
            // 面包导航
            this.$root.breadList = [
                {name: '服务订单', link: ''},
                {name: '核保体检订单', link: ''},
            ]
            this.dataTime()
        },
        async mounted(){
            await this.getOptions()   
            await this.getServiceList();
            await this.getSupplierList();
            await this.getData();
            // this.listenWindow()
        },
        filters: {
            targetStatusFilter(text) {
                let returnText = {
                    WAIT: "待预约",
                    SUCCESS: "已预约（预约成功）",
                    CHECK: "已到检（体检完成）",
                    LATE: "体检逾期",
                    REPORT: "已出报告（已回销）",
                    LOSE: "已撤销",
                    CANCEL: "预约取消",
                    FINISHED: "已完成",
                    ORDER_CANCEL: "订单取消",
                    EXAM_CANCEL: "到检取消"
                }[text]
                return returnText || text
            },
            operationFilter(text) {
                let returnText = {
                    CREATE_ORDER: "生成订单",
                    BOOKING_EXAM: "预约体检",
                    CANCEL_BOOKING: "取消预约",
                    CANCEL_ORDER: "撤销订单",
                    FINISH_EXAM: "完成体检",
                    OVERDUE_EXAM: "体检逾期",
                    CREATE_REPORT: "报告生成",
                    FINISH_ORDER: "完成订单", 
                }[text]
                return returnText || text
            },
            optionsFilter(text, list) {
                let data = list.find((e) => Number(text) == e.value);
                if (data) return data.label;
                else return '';
            },
        },
        methods: {
            //窗口改变，重新取得高度
            listenWindow() {
                this.tableHeight = this.$refs.tableBox.offsetHeight;
                window.addEventListener('resize', ()=>{
                    clearTimeout(this.resizeFlag)
                    this.resizeFlag = setTimeout(() => {
                        try{
                            this.tableHeight = this.$refs.tableBox.offsetHeight || 0;
                        }catch(e){}
                    }, 300);
                })
            },
            async statusHandle(row) {
                const res = await this.axios
                    .get(this.getApiUrl('orderLogList'), {
                        params: {
                            orderId: row.orderId
                        },
                    })
                const count = await this.axios
                    .get(this.getApiUrl('orderLogCancelCount'), {
                        params: {
                            orderId: row.orderId
                        },
                    })
                console.log('res', res.data)
                this.statusData = res.data || []
                this.count = count.data || 0
                this.statustTrackFlag = true;
            },
            // 设置日期选择默认为上月及当月
            dataTime() {
                this.timeDefaultShow = new Date();
                this.timeDefaultShow.setMonth(new Date().getMonth() - 1,1);
            },
            toChangeTime_3( val ){
                if(val){
                    this.searchBox.createStartDate = dateFormat(val[ 0 ]);
                    this.searchBox.createEndDate = dateFormat(val[ 1 ]);
                }else{
                    this.searchBox.createStartDate = '';
                    this.searchBox.createEndDate = ''
                }

            },
            toChangeTime_2( val ){
                if(val){
                    this.searchBox.finishStartDate = dateFormat(val[ 0 ]);
                    this.searchBox.finishEndDate = dateFormat(val[ 1 ]);
                }else{
                    this.searchBox.finishStartDate = '';
                    this.searchBox.finishEndDate = ''
                }

            },
            toChangeTime_1( val ){
                if(val){
                    this.searchBox.bookingStartDate = dateFormat(val[ 0 ]);
                    this.searchBox.bookingEndDate = dateFormat(val[ 1 ]);
                }else{
                    this.searchBox.bookingStartDate = '';
                    this.searchBox.bookingEndDate = '';

                }

            },
            num2Text(id,orderStatus, keyName){
                if(this[keyName] && isArray(this[keyName])){
                    let findItem = this[keyName].find((o) => o.id === id)
                    if (findItem && findItem['label']) {
                        return findItem['label']
                    } else {
                        if (orderStatus == 1) return '待预约'
                        if (orderStatus == 6) return '已撤销'
                        if (orderStatus == 9) return '订单取消'
                        if (orderStatus == 10) return '到检取消'
                        return '未知'
                    }
                    
                }else{
                    return id
                }

            },
            toSearch(){
                this.searchBox.pageNo = 1;
                this.getData()
            },
            toExport(){
                let param = {...this.searchBox};
                Object.keys(param).forEach((key) => {
                    if (Object.prototype.toString.call(param[key]) === "[object Array]") {
                        param[key] = param[key].length == 1 ? param[key][0] : param[key].join(",");
                    }
                })
                let urlPath = this.getApiUrl("orderExport")
                this.$root.exportFile(urlPath,param,"核保体检订单导出")
            },
            downloadFile(item){
                let param = {
                    bookingId: item.bookingId,
                };
                let urlPath = this.getApiUrl("orderReportDownload")
                this.$root.exportFile(urlPath,param,"核保体检订单报告",'.pdf')
            },
            toDetail(item) {
                if (item.reportSource) {
                    this.$router.push({
                        name: "ReportDetail",
                        query: {
                            id: item.bookingId,
                            orderNo: item.orderNo,
                            reportSource: item.reportSource,
                            source: item.source,
                            pathSource: '服务订单,核保体检订单,订单报告详情'
                        },
                    });
                } else {
                    this.$message({
                        type: "warning",
                        message: "暂不支持此类型报告",
                    });
                }
            },
            getSupplierList(){
                this.axios
                    .get(this.getApiUrl('orderProviderList'), {
                        params: {},
                    })
                    .then((res) => {
                        this.supplierList = res.data || [];
                    })
                    .catch((err) => {
                        console.log(err);
                    });

            },
            getData(){
                let apiName = 'orderPage';
                let param = {...this.searchBox};
                Object.keys(param).forEach((key) => {
                    if (Object.prototype.toString.call(param[key]) === "[object Array]") {
                        param[key] = param[key].length == 1 ? param[key][0] : param[key].join(",");
                    }
                })
                this.axios
                    .get(this.getApiUrl(apiName), {
                        params: param,
                    })
                    .then((res) => {
                        let {code, msg, data} = res;
                        if (code === 1) {
                            this.tableData = data.data;
                            this.total = data.total;
                        } else {
                            this.$message.warning(msg);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            handleSizeChange( val ){
                this.searchBox.pageNo = 1;
                this.searchBox.pageSize = val;
                this.getData();
            },
            handleCurrentChange( val ){
                this.searchBox.pageNo = val;
                this.getData();
            },
            /**
             * 获取服务项目列表
             */
            async getServiceList() {
                let res = await this.axios.get(this.getApiUrl("orderItemList"), {
                    params: {},
                });
                this.serviceList = res?.data || [];
            },
            /**
             *  筛选项数据
             */
            async getOptions() {
                // 接口请求
                const res = await this.axios.get(this.getApiUrl("orderOptions"), {
                    params: {}
                });
                if (res.code === 1) {
                    Object.keys(res.data).forEach((item)=>{
                        if(item == "channelList") {
                            res.data[item] = dataArrFormat(res.data[item])
                        }else{
                            res.data[item].forEach((content) => {
                                content.value = content.code || 0
                                content.label = content.name || ""
                            })
                        }
                    })
                    this.optionsData = res.data || {};
                } else {
                    this.$message.warning(res.msg);
                }
            },
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .tableScroll {
        height: 400px;
        overflow-y:scroll;
    }
    .footerInfo {
        margin-top: 30px;
    }
    .search-x{
        min-height: 120px;
        flex-shrink: 0;
        .search-item{
          span{
            display: inline-block;
            width: 100px;
            text-align: right;
          }
        }
    }
    .cont-x{
        flex:1;
        flex-shrink: 0;
    }
</style>
